export const translations = {
  en: {
    // Dashboard
    dashboard: 'Dashboard',
    pages: 'Pages',
    
    // Escrow
    escrow: 'Escrow',
    createEscrow: 'Create Escrow',
    escrowDesc: 'Protect your international payments with a fully digital escrow. Buyer\'s money is securely held and released to the seller on delivery of goods/service/Freelance.',
    
    // Orders
    allOrder: 'All Order',
    completedOrder: 'Completed Order',
    processingOrder: 'Processing Order',
    pendingOrder: 'Pending Order',
    rejectedOrder: 'Rejected Order',
    paymentReceived: 'Payment Received',
    latestOrders: 'Latest Orders',
    noRecentOrders: 'No recent orders found',
    
    // Profile
    profile: 'Profile',
    changePassword: 'Change Password',
    username: 'Username',
    fullName: 'Full Name',
    emailAddress: 'Email address',
    contactNumber: 'Contact Number',
    companyName: 'Company Name',
    country: 'Country',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    
    // Common
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    edit: 'Edit',
    delete: 'Delete',
    logout: 'Logout',
    signOut: 'Sign Out',
    
    // Roles
    buyer: 'Buyer',
    supplier: 'Supplier',
    member: 'Member',
    admin: 'Admin',
    
    // Transactions
    transactions: 'Transactions',
    transactionSummary: 'Transaction Summary',
    escrowDetails: 'Escrow Details',
    escrowId: 'Escrow Id',
    
    // Swapping
    swapping: 'Swapping',
    swap: 'Swap',
    from: 'From',
    to: 'To',
    balance: 'Balance',
    
    // Navigation
    home: 'Home',
    wallet: 'Wallet',
    shop: 'Shop',
    whitepaper: 'Whitepaper',
    roadmap: 'Roadmap',
    
    // Status
    pending: 'Pending',
    completed: 'Completed',
    rejected: 'Rejected',
    inProgress: 'In Progress',
    
    // Sidebar
    generalSetting: 'General Setting',
    myProfile: 'My Profile',
    hvamByMoney: 'HVAM By Money',
    orders: 'Orders',
    customers: 'Customers',
    blockchainSetting: 'Blockchain Setting',
    adminSetting: 'Admin Setting',
    systemSetting: 'System Setting',
    subAdmin: 'Sub Admin',
    rolePermission: 'Role & Permission',
    
    // Auth Pages
    attentionTitle: 'Attention is the new currency',
    attentionSubtitle: 'The more effortless the writing looks, the more effort the writer actually put into the process.',
    signIn: 'Sign In',
    signInSubtitle: 'Enter your email and password to sign in',
    signUp: 'Sign up',
    signingIn: 'Signing in...',
    joinHvam: 'Join HVAM',
    enterYourInfo: 'Enter your Information',
    dontHaveAccount: 'Don\'t have an account?',
    alreadyHaveAccount: 'Already have an account?',
    forgotPassword: 'Forgot Password?',
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordSubtitle: 'Enter your email to check your account',
    email: 'Email',
    password: 'Password',
    mobileNumber: 'Mobile Number',
    selectCountry: 'Select Country',
    agreeTerms: 'I agree to the',
    termsAndConditions: 'Terms and Conditions',
    
    // Transaction Table
    placeOrder: 'Place Order',
    transactionNo: 'TRANSACTION NO.',
    myRoleHeader: 'MY ROLE',
    date: 'DATE',
    status: 'STATUS',
    invoiceAmt: 'INVOICE AMT',
    action: 'ACTION',
    
    // Common Messages
    loginSuccess: 'Login Successfully..',
    registerSuccess: 'Register Successfully..',
    profileUpdated: 'Profile Updated Successfully..',
    escrowCreated: 'Escrow Created Successfully..',
    passwordChanged: 'Password change successfully',
    
    // Create Escrow Form
    transactionSummary: 'Transaction Summary',
    transactionDetails: 'Transaction Details',
    myRole: 'My Role',
    paymentFor: 'Payment For',
    country: 'Country',
    startDate: 'Start Date',
    endDate: 'End Date',
    invoiceAmount: 'Invoice Amount',
    myEmail: 'My Email',
    contactEmail: 'Contact Email',
    contactDetails: 'Contact Details',
    walletAddress: 'Wallet Address',
    description: 'Description',
    address: 'Address',
    additionalDocument: 'Additional Document',
    add: 'Add',
    saveDraft: 'Save Draft',
    submitEscrow: 'Submit Escrow',
    
    // Payment Information
    paymentInformation: 'Payment Information',
    amountToTransfer: 'Amount to transfer to Escrows',
    transactionFees: 'Transaction fees',
    total: 'Total',
    paidByYou: 'Paid by you',
    paymentInfo1: 'The amount will be transferred to Escrows System (excluding fees) and will be safeguarded in a secure Blockchain until your vendor has provided fulfillment proof..',
    paymentInfo2: 'If your vendor does not fulfil the order, amount in escrow will be fully refunded to you',
    
    // Profile Page
    userInformation: 'User Information',
    updateProfile: 'Update Profile',
    passwordDetails: 'Password Details',
    clear: 'Clear',
    
    // Transaction Summary
    escrowDetails: 'Escrow Details',
    
    // Additional
    paymentRelease: 'Payment Release',
    sendLater: 'Send Later',
    placeOrder: 'Place Order',
    iAgreeTerms: 'I agree the',
    paymentNotification: 'We will notify you by email when we receive the documents when we release the payments. You can also log in to your Escrows account to check the status',
    descriptionOfDeal: 'Description of Deal Transaction',
    deliveryAddress: 'Delivery Address',
    
    // HVAM By Money
    buyHvam: 'Buy HVAM',
    noOfHvam: 'No. Of HVAM',
    priceOfHvam: 'Price Of HVAM',
    totalPrice: 'Total Price',
    currency: 'Currency',
    transactionId: 'Transaction ID',
    hashId: 'Hash ID',
    
    // Swapping
    swap: 'Swap',
    tradeTokensInstant: 'Trade tokens in an instant',
    youPay: 'You Pay',
    youReceive: 'You Receive',
    swapNow: 'Swap Now',
    payWith: 'Pay With',
    receive: 'Receive',
    
    // Admin Operations
    adminOperation: 'Admin Operation',
    adminAddress: 'Admin Address',
    tokenSold: 'Token Sold',
    priceChange: 'Price Change',
    addTokenToIco: 'Add Token To ICO',
    tokenStuck: 'Token Stuck',
    setToken: 'Set Token',
    tokenAddress: 'Token Address',
    prev: 'prev',
    next: 'next',
  },
  ar: {
    // Dashboard
    dashboard: 'لوحة التحكم',
    pages: 'الصفحات',
    
    // Escrow
    escrow: 'الضمان',
    createEscrow: 'إنشاء ضمان',
    escrowDesc: 'احمِ مدفوعاتك الدولية بضمان رقمي بالكامل. يتم الاحتفاظ بأموال المشتري بشكل آمن وإطلاقها للبائع عند تسليم البضائع/الخدمة/العمل الحر.',
    
    // Orders
    allOrder: 'جميع الطلبات',
    completedOrder: 'الطلبات المكتملة',
    processingOrder: 'الطلبات قيد المعالجة',
    pendingOrder: 'الطلبات المعلقة',
    rejectedOrder: 'الطلبات المرفوضة',
    paymentReceived: 'المدفوعات المستلمة',
    latestOrders: 'أحدث الطلبات',
    noRecentOrders: 'لم يتم العثور على طلبات حديثة',
    
    // Profile
    profile: 'الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    username: 'اسم المستخدم',
    fullName: 'الاسم الكامل',
    emailAddress: 'عنوان البريد الإلكتروني',
    contactNumber: 'رقم الاتصال',
    companyName: 'اسم الشركة',
    country: 'البلد',
    oldPassword: 'كلمة المرور القديمة',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    
    // Common
    save: 'حفظ',
    cancel: 'إلغاء',
    submit: 'إرسال',
    edit: 'تعديل',
    delete: 'حذف',
    logout: 'تسجيل الخروج',
    signOut: 'تسجيل الخروج',
    
    // Roles
    buyer: 'مشتري',
    supplier: 'مورد',
    member: 'عضو',
    admin: 'مدير',
    
    // Transactions
    transactions: 'المعاملات',
    transactionSummary: 'ملخص المعاملة',
    escrowDetails: 'تفاصيل الضمان',
    escrowId: 'رقم الضمان',
    
    // Swapping
    swapping: 'التبديل',
    swap: 'تبديل',
    from: 'من',
    to: 'إلى',
    balance: 'الرصيد',
    
    // Navigation
    home: 'الرئيسية',
    wallet: 'المحفظة',
    shop: 'المتجر',
    whitepaper: 'الورقة البيضاء',
    roadmap: 'خارطة الطريق',
    
    // Status
    pending: 'معلق',
    completed: 'مكتمل',
    rejected: 'مرفوض',
    inProgress: 'قيد التنفيذ',
    
    // Sidebar
    generalSetting: 'الإعدادات العامة',
    myProfile: 'ملفي الشخصي',
    hvamByMoney: 'HVAM بالمال',
    orders: 'الطلبات',
    customers: 'العملاء',
    blockchainSetting: 'إعدادات البلوك تشين',
    adminSetting: 'إعدادات المدير',
    systemSetting: 'إعدادات النظام',
    subAdmin: 'مدير فرعي',
    rolePermission: 'الدور والصلاحيات',
    
    // Auth Pages
    attentionTitle: 'الانتباه هو العملة الجديدة',
    attentionSubtitle: 'كلما بدا الكتابة أكثر سهولة، زاد الجهد الذي بذله الكاتب في العملية.',
    signIn: 'تسجيل الدخول',
    signInSubtitle: 'أدخل بريدك الإلكتروني وكلمة المرور لتسجيل الدخول',
    signUp: 'التسجيل',
    signingIn: 'جاري تسجيل الدخول...',
    joinHvam: 'انضم إلى HVAM',
    enterYourInfo: 'أدخل معلوماتك',
    dontHaveAccount: 'ليس لديك حساب؟',
    alreadyHaveAccount: 'هل لديك حساب بالفعل؟',
    forgotPassword: 'نسيت كلمة المرور؟',
    forgotPasswordTitle: 'نسيت كلمة المرور',
    forgotPasswordSubtitle: 'أدخل بريدك الإلكتروني للتحقق من حسابك',
    email: 'البريد الإلكتروني',
    password: 'كلمة المرور',
    mobileNumber: 'رقم الجوال',
    selectCountry: 'اختر البلد',
    agreeTerms: 'أوافق على',
    termsAndConditions: 'الشروط والأحكام',
    
    // Transaction Table
    placeOrder: 'تقديم طلب',
    transactionNo: 'رقم المعاملة',
    myRoleHeader: 'دوري',
    date: 'التاريخ',
    status: 'الحالة',
    invoiceAmt: 'مبلغ الفاتورة',
    action: 'الإجراء',
    
    // Common Messages
    loginSuccess: 'تم تسجيل الدخول بنجاح..',
    registerSuccess: 'تم التسجيل بنجاح..',
    profileUpdated: 'تم تحديث الملف الشخصي بنجاح..',
    escrowCreated: 'تم إنشاء الضمان بنجاح..',
    passwordChanged: 'تم تغيير كلمة المرور بنجاح',
    
    // Create Escrow Form
    transactionSummary: 'ملخص المعاملة',
    transactionDetails: 'تفاصيل المعاملة',
    myRole: 'دوري',
    paymentFor: 'الدفع مقابل',
    country: 'البلد',
    startDate: 'تاريخ البدء',
    endDate: 'تاريخ الانتهاء',
    invoiceAmount: 'مبلغ الفاتورة',
    myEmail: 'بريدي الإلكتروني',
    contactEmail: 'البريد الإلكتروني للاتصال',
    contactDetails: 'تفاصيل الاتصال',
    walletAddress: 'عنوان المحفظة',
    description: 'الوصف',
    address: 'العنوان',
    additionalDocument: 'مستند إضافي',
    add: 'إضافة',
    saveDraft: 'حفظ كمسودة',
    submitEscrow: 'إرسال الضمان',
    
    // Payment Information
    paymentInformation: 'معلومات الدفع',
    amountToTransfer: 'المبلغ المراد تحويله إلى الضمان',
    transactionFees: 'رسوم المعاملة',
    total: 'الإجمالي',
    paidByYou: 'مدفوع من قبلك',
    paymentInfo1: 'سيتم تحويل المبلغ إلى نظام الضمان (باستثناء الرسوم) وسيتم حمايته في سلسلة الكتل الآمنة حتى يقدم البائع إثبات الوفاء.',
    paymentInfo2: 'إذا لم يقم البائع بتنفيذ الطلب، سيتم استرداد المبلغ في الضمان بالكامل إليك',
    
    // Profile Page
    userInformation: 'معلومات المستخدم',
    updateProfile: 'تحديث الملف الشخصي',
    passwordDetails: 'تفاصيل كلمة المرور',
    clear: 'مسح',
    
    // Transaction Summary
    escrowDetails: 'تفاصيل الضمان',
    
    // Additional
    paymentRelease: 'إطلاق الدفع',
    sendLater: 'إرسال لاحقاً',
    placeOrder: 'تقديم طلب',
    iAgreeTerms: 'أوافق على',
    paymentNotification: 'سنخطرك بالبريد الإلكتروني عند استلام المستندات وعند إطلاق المدفوعات. يمكنك أيضًا تسجيل الدخول إلى حساب الضمان الخاص بك للتحقق من الحالة',
    descriptionOfDeal: 'وصف معاملة الصفقة',
    deliveryAddress: 'عنوان التسليم',
    
    // HVAM By Money
    buyHvam: 'شراء HVAM',
    noOfHvam: 'عدد HVAM',
    priceOfHvam: 'سعر HVAM',
    totalPrice: 'السعر الإجمالي',
    currency: 'العملة',
    transactionId: 'رقم المعاملة',
    hashId: 'معرف الهاش',
    
    // Swapping
    swap: 'تبديل',
    tradeTokensInstant: 'تداول الرموز في لحظة',
    youPay: 'أنت تدفع',
    youReceive: 'أنت تستلم',
    swapNow: 'تبديل الآن',
    payWith: 'الدفع بـ',
    receive: 'استلام',
    
    // Admin Operations
    adminOperation: 'عملية المدير',
    adminAddress: 'عنوان المدير',
    tokenSold: 'الرمز المباع',
    priceChange: 'تغيير السعر',
    addTokenToIco: 'إضافة رمز إلى ICO',
    tokenStuck: 'الرمز عالق',
    setToken: 'تعيين الرمز',
    tokenAddress: 'عنوان الرمز',
    receivingAddress: 'عنوان الاستلام',
    receivingAccountAddress: 'عنوان حساب الاستلام',
    submit: 'إرسال',
    prev: 'السابق',
    next: 'التالي',
  },
};
